<div [formGroup]="formService.form">
  <ng-container formGroupName="properties">
    <ion-item>
      <ion-input formControlName="name" label="Title"></ion-input>
    </ion-item>
    <ion-item>
      <ion-input formControlName="ref" label="Ref"></ion-input>
    </ion-item>
  </ng-container>
  <ion-item>
    <ng-container *ngIf="pipelines$ | async as pipelines">
      <ion-select formControlName="pipeline_id" placeholder="Select one" label="Pipeline">
        <ion-select-option *ngFor="let pipeline of pipelines" [value]="pipeline.id">
          {{pipeline.name}}
        </ion-select-option>
      </ion-select>
    </ng-container>
  </ion-item>

  <div *ngIf="formService.form.dirty || !this.id" class="ion-margin ion-text-right">
    <dd-entity-form-submit [disabled]="!formService.form.valid" (submitted)="submit()"
                           label="Save"></dd-entity-form-submit>
  </div>

</div>
